import FinderResultItem from './FinderResultItem'
export default FinderResultItem
export { FinderResultIntroLength } from './FinderResultItem'
export type { DetailItem } from './FinderResultItem'
